import {
  IDeletePropertyPhotoDTO,
  IGetPropertyPhotosDTO,
  IPropertyPhotosResponse,
  PhotosEndpoints,
  IUploadPropertyPhotosDTO,
} from '@/models/photos.model';
import { ApiResponse, getEntityId, httpClient } from '@/utils';

class PhotosAPI {
  static getPropertyPhotos({ property_id, ...params }: IGetPropertyPhotosDTO): ApiResponse<IPropertyPhotosResponse> {
    return httpClient.get<IPropertyPhotosResponse>(
      `${PhotosEndpoints.PROPERTY_PHOTOS}/${getEntityId(property_id)}/files/photos`,
      {
        params,
      },
    );
  }

  static uploadPropertyPhotos({
    property_id,
    ...data
  }: IUploadPropertyPhotosDTO): ApiResponse<IPropertyPhotosResponse> {
    return httpClient.put<IPropertyPhotosResponse>(
      `${PhotosEndpoints.PROPERTY_PHOTOS}/${getEntityId(property_id)}/files/photos`,
      data,
    );
  }

  static deletePhoto({ file_id, property_id }: IDeletePropertyPhotoDTO): ApiResponse<IPropertyPhotosResponse> {
    return httpClient.delete<IPropertyPhotosResponse>(
      `${PhotosEndpoints.PROPERTY_PHOTOS}/${getEntityId(property_id)}/files/photos/${getEntityId(file_id)}`,
    );
  }
}

export default PhotosAPI;
